/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Toast from './sub_components/toast';
import * as eventService from '../services/eventService'
import * as marketService from '../services/marketService'
import * as currentBetsService from '../services/currentBetsService'
import * as apiUserService from '../services/apiUserService'
import * as userService from '../services/userService'
import * as utilService from '../services/utilService'
import ScoreBoard from './sub_components/marketanalysis/scoreboard'
import SoccerBoard from './sub_components/marketanalysis/soccerBoard'
import TennisBoard from './sub_components/marketanalysis/tennisBoard'
import KabaddiBoard from './sub_components/marketanalysis/kabaddiBoard'
import ElectionBoard from './sub_components/marketanalysis/electionBoard'
import WebMarket from './sub_components/marketanalysis/webmarket'
import BinaryMarket from './sub_components/marketanalysis/binarymarket'
import ExpoPopup from './sub_components/marketanalysis/expoPopup'
import Currency from './sub_components/currency'
import EventUnsettledBets from './sub_components/eventUnsettledBets'
import UserMarketBook from './sub_components/userMarketBook'
import AverageMarketBook from './sub_components/averageMarketBook'
import MarketBetLock from './sub_components/marketBetLock'
import socketIOClient from "socket.io-client";
// import { liveSocketEndPoint } from "../configs/const"
import * as stringParser from "../util/string.util"
import * as dateUtil from "../util/date.util"
import { BASE_IMAGE_PATH, SOCKET_ROOT as liveSocketEndPoint } from '../configs/api'
import GraphicScore from './sub_components/marketanalysis/graphicScore';
import reactCsv from 'react-csv';

let accessToken = !!localStorage.getItem("userAuthDetail") ? JSON.parse(localStorage.getItem("userAuthDetail")).token : "";
let socket = null;
let beep = null;
let dataUpdate
class BinaryAnalysisUsers extends Component {
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         showPopupBets: false,
         showPopupUserBook: false,
         showPopupBetsLock: false,
         showPopupFancyBook: false,
         showBetsLockMenu: false,
         showFancyLockMenu: false,
         showMarketBetDetail: false,
         showUserDetailPopup: false,
         betsClientsIP: "",
         betsAmountFrom: "",
         betsAmountTo: "",
         userBetDelay: "",
         masterPassword: "",
         userBetLock: false,
         marketBetDetail: [],
         marketuserDetail: [],
         userDetail: [],
         usermktData: {},
         eventData: {},
         fancyMarkets: [],
         lineMarkets: [],
         oddsMarkets: [],
         matched_bet: [],
         matched_bet_filter: [],
         showExpo: false,
         lineExpo: {},
         tvUrl: "",
         toastMsg: "",
         toastType: "",
         showToast: false,
         bets_data: [],
         accounts: "",
         frontData: {},
         betListLimit: 20,
         betFilter: "",
         mktFeedBooks: {},
         openUserBook: false,
         bookMkt: {},
         dailyCount: 0,
         hour1Count: 0,
         hour2Count: 0,
         newPopupData: false,
         deactivatMarkets: [],
         deactivatOrders: [],
         eventDetail: {},
         tvShow: false,
         fancyFilter: "all",
         showFancy: true,
         hideMkt: [],
         beepAllow: false,
         isBeepPlaying: false,
         avgBookPopup: false,
         avgMarket: {},
         avgCurrRunnerId: "",
         marketExpos: {},
         showMarketBetLock: false,
         marketMsg: {},
         betLockMkt: {},
         isGraphicScore: false,
         subscribedMarkets: [],
         scoreUrl: "",
         expoPrice: null,
         isEventUpdate: false,
         marketType:"",
      };
   }
   async resultDeclered(type, payload) {
      let deactivatMarkets = this.state.deactivatMarkets
      let deactivatOrders = this.state.deactivatOrders
      if (type === "market") {
         if (!!payload && !!payload.marketId) {
            deactivatMarkets.push(payload.marketId)
         }
      } else if (type === "order") {
         if (!!payload && !!payload.orderId) {
            deactivatOrders.push(payload.orderId)
         }
      } else if (type === "rollback") {
         if (!!payload && !!payload.marketId) {
            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
               deactivatMarkets.splice(index, 1)
            }
            this.onSubmitForm()
         }
      } else if (type === "marketvoid") {
         if (!!payload && !!payload.marketId) {
            deactivatMarkets.push(payload.marketId)
         }
      }
      this.setState({ deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders }, async () => {
         let expos = await marketService.getEventResults(this.props.match.params.event_id)
         expos = expos.items
         this.calculateCount(expos)
      })
   }
   async componentDidMount() {
      beep = document.getElementById("beepplay");
      let userData = localStorage.getItem("tokenData")
      let mktExpos = {}
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth")
      }
      this.setState({ accounts: userData.sub },
         () => {
            this.onSubmitForm()
         }
      )

      if (accessToken !== "" && accessToken) {
         socket = socketIOClient(liveSocketEndPoint, {
            query: 'token=' + accessToken,
            transports: ["websocket"]
         });
      }

      let eventData = await eventService.getUserEventById(this.props.match.params.event_id)
      let expos = await marketService.getEventResults(this.props.match.params.event_id)
      expos = expos.items

      let tvUrl = !!eventData.metadata && !!eventData.metadata.tvUrl ? eventData.metadata.tvUrl : ""

   //    if ((eventData.eventType.id === "1" || eventData.eventType.id === "2") && tvUrl.includes("ip=")) {
   //       let ipData = await utilService.getClientIp()
   //       tvUrl = tvUrl + ipData.IPv4
   //   }
      let msgs = !!eventData.metadata && !!eventData.metadata.messages ? JSON.parse(eventData.metadata.messages) : {}
      let inActiveMkts = !!eventData.metadata && !!eventData.metadata.inactiveMarkets ? JSON.parse(eventData.metadata.inactiveMarkets) : []

      this.setState({ marketMsg: msgs, score_id: !!eventData.metadata && !!eventData.metadata.scoreUrl ? eventData.metadata.scoreUrl : "" })
      // setInterval(async () => {
      //    let msgs = await eventService.getEventMktMessages(this.props.match.params.event_id)
      //    this.setState({ marketMsg: msgs })
      // }, 6000)

      this.calculateCount(expos)
      if (eventData.metadata && !!eventData.metadata.score) {
         this.setState({ frontData: JSON.parse(eventData.metadata.score) })
      }

      if (!eventData.catalogues) {
         return false
      }
      eventData.catalogues = !!eventData.catalogues ? eventData.catalogues.filter((mkt) => {
         return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
      }) : []
      !!eventData.catalogues && Array.prototype.forEach.call(eventData.catalogues,(market, i) => {
         let mkt_exposour = !!expos ? expos.filter((exp) => {
            return exp.marketId === market.marketId
         }) : []
         mktExpos[market.marketId] = mkt_exposour.length > 0 ? mkt_exposour[0] : {}
         if (!!eventData.metadata && !!eventData.metadata.books) {
            // let mktBook = stringParser.deSrlz("book|" + eventData.metadata.books[market.marketId])
            let mktBookData = JSON.parse(eventData.metadata.books)
            let mktBook = !!mktBookData && !!mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : {}
            eventData.catalogues[i].metadata = {}
            eventData.catalogues[i].metadata.book = mktBook
         } else {
            let baseData = {
               marketId: market.marketId,
               status: "OPEN",
               runners: []
            }
            Array.prototype.forEach.call(eventData.catalogues[i].runners,(rnr) => {
               let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
               baseData.runners.push(data)
            })
            eventData.catalogues[i].metadata = {}
            eventData.catalogues[i].metadata.book = baseData
         }
      })

      var moPos = eventData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
      if (moPos !== -1) {
         let mom = [eventData.catalogues[moPos]]
         eventData.catalogues.splice(moPos, 1)
         eventData.catalogues = mom.concat(eventData.catalogues)
      }
      let fancy_mkts = eventData.catalogues && eventData.catalogues.filter((mkt) => {
         return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE"
      })
      let line_mkts = []
      // let line_mkts = eventData.catalogues && eventData.catalogues.filter((mkt) => {
      //    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && mkt.provider === "BETFAIR" && mkt.bettingType === "LINE" && !!mkt.metadata && !!mkt.metadata.books
      // })
      let odds_mkts = eventData.catalogues && eventData.catalogues.filter((mkt) => {
         return (mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE") && !!mkt.metadata && !!mkt.metadata.book && mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE"
      })

      fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
      let mBets = []
      let self = this
      this.setState({ eventDetail: eventData, eventData: eventData, lineMarkets: line_mkts, matched_bet: mBets, fancyMarkets: fancy_mkts, oddsMarkets: odds_mkts, tvUrl: tvUrl, marketExpos: mktExpos })
      
      beep.addEventListener('ended', (e)=>{
         this.setState({
            isBeepPlaying:false
         },()=>{
            // console.log('two - ' + (new Date()).toISOString())
         })
      })

      socket.emit('user_room', userData.sub);
      socket.emit('site_room', userData.sub);
      socket.on("site_room", data => {
         let msg = JSON.parse(data);
         if (!!msg.command && (msg.command === "SPORTSBETPLACED" || msg.command === "BINARYBETPLACED")) {
            let expos = this.state.marketExpos
            data = JSON.parse(data).payload
            if (self.props.match.params.event_id !== data.eventId) {
               return false
            }
            let bets_data = self.state.bets_data
            data.side = data.side === "BACK" ? 0 : 1
            let newDateIndex = bets_data.findIndex((bets, i) => {
               return bets.orderId === msg.payload.orderId
            })
            let newData = [msg.payload]
            if(newDateIndex > -1){
               newData = bets_data
            }
            else{
               newData = newData.concat(bets_data)
            }
               newData = newData.splice(0, 50)

            if (this.state.beepAllow && !this.state.isBeepPlaying) {
               // beepaudio.play()
               this.setState({
                  isBeepPlaying:true
               }, ()=>{
                  try{
                     beep.play()
                  }
                  catch(e){
                     
                  }
                  // beep.click()
                  // document.getElementById("beepplay").click()
                  // console.log('beep one - ' + (new Date()).toISOString())
               })
               // var playPromise = beep.play();
 
               // if (playPromise !== undefined) {
               //    playPromise.then(_ => {
               //       // Automatic playback started!
               //       // Show playing UI.
               //       // We can now safely pause video...
               //       //beep.pause();
               //       // beep.
               //       console.log('beep then - ' + (new Date()).toISOString())
               //    })
               //    .catch(error => {
               //       console.log('beep error - ' + (new Date()).toISOString())
               //       console.log(error)
               //       // Auto-play was prevented
               //       // Show paused UI.
               //    });
               // }
            }
            if (!!expos[data.marketId]) {
               expos[data.marketId].runnersExposure = data.runnersExposure
            } else {
               expos[data.marketId] = {}
               expos[data.marketId].runnersExposure = data.runnersExposure
            }
            this.setState({ marketExpos: expos })
            if (data.marketType === "DAILY") {
               self.setState({ bets_data: [] }, () => {
                  self.setState({ bets_data: newData, dailyCount: self.state.dailyCount + 1, newPopupData: true })
               })
            }else if (data.marketType === "1_HOUR") {
               self.setState({ bets_data: [] }, () => {
                  self.setState({ bets_data: newData, hour1Count: self.state.hour1Count + 1, newPopupData: true })
               })
            }else if (data.marketType === "2_HOUR") {
               self.setState({ bets_data: [] }, () => {
                  self.setState({ bets_data: newData, hour2Count: self.state.hour2Count + 1, newPopupData: true })
               })
            } 
         }
         if (!!msg.command && (msg.command === "RESULTDECLARED" || msg.command === "BINARYRESULTDECLARED")) {
            self.resultDeclered("market", msg.payload)
            if (msg.payload.pnl > 0) {
               self.props.notify("Congratulations! You WON " + msg.payload.pnl + " from your bets on " + msg.payload.marketName + ". 🤑", "success")
            } else if (msg.payload.pnl < 0) {
               self.props.notify("Oops! You lost " + msg.payload.pnl + " from your bets on " + msg.payload.marketName + ". 😢", "error")
            }
         }
         if (!!msg.command && (msg.command === "VOIDORDER" || msg.command === "BINARYVOIDORDER")) {
            self.resultDeclered("order", msg.payload)
            if (msg.payload.pnl > 0) {
               self.props.notify("Your account has been credited with " + msg.payload.pnl + " because of rollback in " + msg.payload.marketName + ".", "success")
            } else if (msg.payload.pnl < 0) {
               self.props.notify("Your account has been debited with " + msg.payload.pnl + " due to rollback in " + msg.payload.marketName + ".", "error")
            }
         }
         if (!!msg.command && (msg.command === "RESULTROLLBACK" || msg.command === "BINARYRESULTROLLBACK")) {
            self.resultDeclered("rollback", msg.payload)
         }
         if (!!msg.command && msg.command === "Orders.NotifyVoidSportsMarket") {
            self.resultDeclered("market", msg.payload)
         }
         if (!!msg.command && (msg.command === "SPORTSMARKETVOID" || msg.command === "BINARYMARKETVOID")) {
            self.resultDeclered("marketvoid", msg.payload)
            self.props.notify(" Market " + msg.payload.marketName + " is Voided !", "error")
         }
      })
      socket.on('disconnect', () => {
         socket.emit('user_room', userData.sub);
         socket.emit('site_room', userData.sub);
      })
      dataUpdate = setInterval(async function updatedData() {
         clearInterval(dataUpdate)
         let mBets = []
         eventData = await eventService.getUserEventById(self.props.match.params.event_id)
         if (!eventData.catalogues) {
            dataUpdate = setInterval(updatedData, 5000)
            return false
         }

         let msgs = !!eventData.metadata && !!eventData.metadata.messages ? JSON.parse(eventData.metadata.messages) : {}
         let inActiveMkts = !!eventData.metadata && !!eventData.metadata.inactiveMarkets ? JSON.parse(eventData.metadata.inactiveMarkets) : []

         self.setState({ marketMsg: msgs })

         eventData.catalogues = eventData.catalogues.filter((mkt) => {
            return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
         })
         // self.calculateCount(expos)
         // let expos = await marketService.getEventResults(self.props.match.params.event_id)
         !!eventData.catalogues && Array.prototype.forEach.call(eventData.catalogues,(market, i) => {
            // let mkt_exposour = !!expos && expos.filter((exp) => {
            //    return exp.marketId === market.marketId
            // })
            // eventData.catalogues[i].expo = mkt_exposour.length > 0 ? mkt_exposour[0] : {}
            if (!!eventData.metadata && !!eventData.metadata.books) {
               // let mktBook = stringParser.deSrlz("book|" + eventData.metadata.books[market.marketId])
               let mktBookData = JSON.parse(eventData.metadata.books)
               let mktBook = !!mktBookData && mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : {}
               eventData.catalogues[i].metadata = {}
               eventData.catalogues[i].metadata.book = mktBook
            } else {
               let baseData = {
                  marketId: market.marketId,
                  status: "OPEN",
                  runners: []
               }
               Array.prototype.forEach.call(eventData.catalogues[i].runners,(rnr) => {
                  let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                  baseData.runners.push(data)
               })
               eventData.catalogues[i].metadata = {}
               eventData.catalogues[i].metadata.book = baseData
            }
         })
         var moPos = !!eventData.catalogues && eventData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
         if (!!eventData && eventData.catalogues && moPos !== -1) {
            let mom = [eventData.catalogues[moPos]]
            eventData.catalogues.splice(moPos, 1)
            eventData.catalogues = mom.concat(eventData.catalogues)
         }
         let fancy_mkts = !!eventData.catalogues && eventData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
         })
         let line_mkts = []
         // let line_mkts = !!eventData.catalogues && eventData.catalogues.filter((mkt) => {
         //    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && mkt.provider === "BETFAIR" && mkt.bettingType === "LINE" && !!mkt.metadata && !!mkt.metadata.books && !!mkt.metadata.book.marketId
         // })
         let odds_mkts = !!eventData.catalogues && eventData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE") && !!mkt.metadata && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
         })
         fancy_mkts = fancy_mkts.length > 0 ? fancy_mkts.sort((a, b) => a.marketId - b.marketId) : [];
         // self.setState({ eventData: {}, lineMarkets: [], fancyMarkets: [], oddsMarkets: [] }, () => {
         self.setState({ eventData: {}, oddsMarkets: [], isEventUpdate:true }, () => {
            self.setState({ eventData: eventData, lineMarkets: line_mkts, fancyMarkets: fancy_mkts, oddsMarkets: odds_mkts, matched_bet: mBets, matched_bet_filter: mBets },()=>{
               self.setState({ isEventUpdate:false})
            })
            dataUpdate = setInterval(updatedData, 15000)
         })
      }
         , 15000)
      window.addEventListener("scroll", () => {
         let headerHeight = document.getElementById("menu").offsetHeight
         let betSLipMenuOffset = window.pageYOffset
         if (betSLipMenuOffset > headerHeight) {
            document.getElementById("main-analysis-st").style.top = headerHeight.toString() + "px"
            document.getElementById("main-analysis-st").classList.add("sticky");
         } else {
            document.getElementById("main-analysis-st").style.removeProperty("top")
            document.getElementById("main-analysis-st").classList.remove("sticky");
         }
      })
   }
   calculateCount(expos) {
      let dailyCount = 0
      let hour1Count = 0
      let hour2Count = 0
      !!expos && Array.prototype.forEach.call(expos,(mkt) => {
         if (mkt.marketType === "DAILY") {
            dailyCount = dailyCount + mkt.orderCount
         } else if (mkt.marketType === "1_HOUR") {
            hour1Count = hour1Count + mkt.orderCount
         } else if (mkt.marketType === "2_HOUR") {
            hour2Count = hour2Count + mkt.orderCount
         }
      })
      this.setState({ dailyCount: dailyCount, hour1Count: hour1Count, hour2Count: hour2Count })
   }
   async onSubmitForm() {
      // let body = {
      //    "filters": {
      //       "BetStatuses": ["PLACED", "REQUESTED", "REJECTED"],
      //       "current_user": this.state.accounts,
      //       "user_id": "",
      //       "amount_from": 0.0,
      //       "amount_to": 0.0,
      //       "market_id": "",
      //       "event_id": this.props.match.params.event_id,
      //       "competition_id": "",
      //       "sport_type": "",
      //       "market_type": "",
      //    },
      //    "last_id": "",
      //    "first_id": "",
      //    "action": "",
      //    "from": "",
      //    "to": "",
      //    "page_no": 1,
      //    "count_records": 0,
      //    "records_display": this.state.betListLimit
      // }
      let body = {
         "filters":{
             "userId": "",
             "betStatus": ["PLACED", "REQUESTED", "REJECTED"],
             "marketId": "",
             "eventId": this.props.match.params.event_id,
             "competitionId": "",
             "sportType": "",
             "marketType": "",
             "amountFrom": "",
             "amountTo": ""
         },
         "lastId": "",
         "firstId": "",
         "action": "",
         "from": "",
         "to": "",
         "countRecords": 0,
         "pageNo": 1,
         "recordsPerPage": this.state.betListLimit
     
     }
      body = this.clean(body);
      const self = this;
      await currentBetsService.postApiOpenBets(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  bets_data: [],
               }, () => {
                  self.setState({ bets_data: res.items })
               }
            );
         }
         else {
            // this.setState({ bets_data: [] })
         }
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   openUserBooks(mkt) {
      this.setState({ bookMkt: mkt, openUserBook: true })
   }
   closeUserBook() {
      this.setState({ bookMkt: "", openUserBook: false })
   }
   showMarketBetLock(mkt) {
      this.setState({ betLockMkt: mkt, showMarketBetLock: true })
   }
   closeMarketBetLock() {
      this.setState({ showMarketBetLock: false, betLockMkt: {} })
   }
   showAvgBookPopup(mkt, currRunnerId) {
      this.setState({ avgBookPopup: true, avgMarket: mkt, avgCurrRunnerId: currRunnerId })
   }
   hideAvgBookPopup() {
      this.setState({ avgBookPopup: false, avgMarket: {} })
   }
   newPopupData() {
      this.setState({ newPopupData: false })
   }
   hideUserDetailPopup() {
      this.setState({ showUserDetailPopup: false, userBetDelay: "", userBetLock: false })
   }
   async showUserDetailPopup(bet) {
      let userData = await apiUserService.getDashboard(bet.username)
      let usermktData = await userService.getUserMarketExposure(bet.username, bet.marketId);
      usermktData = usermktData.items
      this.setState({ userDetail: [], marketuserDetail: [], usermktData: {}, userBetDelay: "", userBetLock: false }, () => {
         this.setState({
            userDetail: bet,
            marketuserDetail: userData,
            userBetDelay: userData.betDelay,
            userBetLock: userData.betLock,
            usermktData: usermktData[0],
            showUserDetailPopup: true
         })
      })
   }
   hidePopupBets() {
      this.setState({ showPopupBets: false, })
   }
   showPopupBets() {
      this.setState({ showPopupBets: true, })
   }
   hideMarketBetDetail() {
      this.setState({ showMarketBetDetail: false })
   }
   showMarketBetDetail(bet) {
      this.setState({ showMarketBetDetail: true, marketBetDetail: [] }, () => { this.setState({ marketBetDetail: bet }) })
   }
   hidePopupUserBook() {
      this.setState({ showPopupUserBook: false, })
   }
   showPopupUserBook() {
      this.setState({ showPopupUserBook: true, })
   }
   hidePopupBetsLock() {
      this.setState({ showPopupBetsLock: false, })
   }
   showPopupBetsLock() {
      this.setState({ showPopupBetsLock: true, })
   }
   hidePopupFancyBook() {
      this.setState({ showPopupFancyBook: false, })
   }
   showPopupFancyBook() {
      this.setState({ showPopupFancyBook: true, })
   }
   hideBetsLockMenu() {
      this.setState({ showBetsLockMenu: false, })
   }
   showBetsLockMenu() {
      this.setState({ showBetsLockMenu: true, })
   }
   hideFancyLockMenu() {
      this.setState({ showFancyLockMenu: false, })
   }
   showFancyLockMenu() {
      this.setState({ showFancyLockMenu: true, })
   }

   showExpo(data, price) {
      this.setState({ showExpo: true, lineExpo: data, expoPrice: price })
   }
   hideExpo() {
      this.setState({ showExpo: false, lineExpo: {} })
   }
   betsSearch() {
      let mbt = this.state.matched_bet
      let amountFrom = parseFloat(this.state.betsAmountFrom)
      let amountTo = parseFloat(this.state.betsAmountTo)
      let clientIP = this.state.betsClientsIP
      if (!!amountFrom && !!amountTo) {
         if (amountTo < amountFrom) {
            amountFrom = this.state.betsAmountTo
            amountTo = this.state.betsAmountFrom
         }
         mbt = mbt.filter(m => { return m.amount >= amountFrom && m.amount <= amountTo })
      }
      else if (!!amountFrom) {
         mbt = mbt.filter(m => { return m.amount >= amountFrom })
      }
      else if (!!amountTo) {
         mbt = mbt.filter(m => { return m.amount <= amountTo })
      }

      if (clientIP !== "") {
         mbt = mbt.filter(m => { return m.clientIP === clientIP })
      }
      this.setState({ matched_bet_filter: mbt })
   }
   betsViewAll() {
      this.setState({ matched_bet_filter: this.state.matched_bet, betsAmountTo: "", betsAmountFrom: "", betsClientsIP: "" })
   }
   async onUserBetLock(user) {
      if (!this.state.masterPassword) {
         this.props.notify("Please insert master password!", "error");
         return false
      }
      let body = {
         "username": user,
         "password": this.state.masterPassword
      }
      if (this.state.userBetLock) {
         await userService.blockUser(body).then((res) => {
            if (res.isSuccess) {
               this.props.notify("Bet Locked Succesfully!", "success");
            } else {
               this.props.notify(res.exception.message, "error")
            }
         })
      } else {
         await userService.unBlockUser(body).then((res) => {
            if (res.isSuccess) {
               this.props.notify("Bet Locked Succesfully!", "success");
            } else {
               this.props.notify(res.exception.message, "error")
            }
         })
      }
      this.setState({ masterPassword: "" })
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   onCheckChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   applyFilter(market) {
      this.setState({ betFilter: market, marketType: "" })
   }
   updateBook(marketId, book) {
      let feedBooks = this.state.mktFeedBooks
      feedBooks[marketId] = book
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.mktFeedBooks = feedBooks
   }

   filteredBets() {
      let btFilter = this.state.betFilter
      let bets = this.state.bets_data
      bets = bets.filter((bet) => {
         return this.state.deactivatMarkets.indexOf(bet.marketId) === -1
      })
      bets = bets.filter((bet) => {
         return this.state.deactivatOrders.indexOf(bet.orderId) === -1
      })

      if(!!this.state.marketType){
         bets = bets.filter((bet) => {
            return this.state.marketType === bet.marketType
         })
      }

      if (btFilter === "") {
         return bets
      } else if (btFilter === "LINE") {
         return bets.filter((bt, i) => {
            return bt.marketBettingType === "LINE"
         })
      } else {
         return bets.filter((bt, i) => {
            return bt.marketId === btFilter
         })
      }

   }
   arrayGroupBy(ary, attr) {
      let group = ary.reduce((r, a) => {
         r[a[attr]] = [...r[a[attr]] || [], a];
         return r;
      }, {});
      return group
   }
   orgenizedFancy(markets) {
      if (!markets) {
         return {}
      }
      let newObj = {}

      if (!!markets["THREE_SELECTIONS"]) {
         newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"]
         delete markets["THREE_SELECTIONS"]
      }
      if (!!markets["1ST_INNINGS_RUNS"]) {
         newObj["1ST_INNINGS_RUNS"] = markets["1ST_INNINGS_RUNS"]
         delete markets["1ST_INNINGS_RUNS"]
      }
      if (!!markets["2ND_INNINGS_RUNS"]) {
         newObj["2ND_INNINGS_RUNS"] = markets["2ND_INNINGS_RUNS"]
         delete markets["2ND_INNINGS_RUNS"]
      }
      if (!!markets["SINGLE_OVER"]) {
         newObj["SINGLE_OVER"] = markets["SINGLE_OVER"]
         delete markets["SINGLE_OVER"]
      }
      if (!!markets["OVERS"]) {
         newObj["OVERS"] = markets["OVERS"]
         delete markets["OVERS"]
      }
      if (!!markets["BALL_BY_BALL"]) {
         newObj["BALL_BY_BALL"] = markets["BALL_BY_BALL"]
         delete markets["BALL_BY_BALL"]
      }
      if (!!markets["BATSMAN"]) {
         newObj["BATSMAN"] = markets["BATSMAN"]
         delete markets["BATSMAN"]
      }
      if (!!markets["ODD_EVEN"]) {
         newObj["ODD_EVEN"] = markets["ODD_EVEN"]
         delete markets["ODD_EVEN"]
      }
      if (!!markets["OTHERS"]) {
         newObj["OTHERS"] = markets["OTHERS"]
         delete markets["OTHERS"]
      }
      newObj = { ...newObj, ...markets }
      let fancys = []
      Array.prototype.forEach.call(Object.keys(newObj),(type) => {
         fancys = fancys.concat(newObj[type])
      })
      return fancys
   }
   applyFancyFilter(flt) {
      this.setState({ fancyFilter: "" }, () => {
         this.setState({ fancyFilter: flt })
      })
   }
   fancyFilterApply(mktList) {
      let filter = this.state.fancyFilter
      if (filter !== "all") {
         mktList = mktList.filter((mkt, i) => {
            return mkt.marketType === filter
         })
      }
      return mktList
   }
   toggleOpenMkt(mktId) {
      let hideMkt = this.state.hideMkt
      let mktIndex = hideMkt.indexOf(mktId)
      if (mktIndex === -1) {
         hideMkt.push(mktId)
      } else {
         hideMkt.splice(mktIndex, 1)
      }
      this.setState({ hideMkt: hideMkt })
   }

   updateSubscribedMarkets(mkt) {
      let mktList = this.state.subscribedMarkets
      mktList.push(mkt)
      this.setState({ subscribedMarkets: mktList })
   }
   componentWillUnmount(){
      beep.removeEventListener('ended', null)
      window.removeEventListener('scroll', null)
      clearInterval(dataUpdate)
   }

   beepAudioClick(){
      beep.play();
   }
   sortGameCatalogues(catArray){
      let mktArray = catArray
      mktArray = mktArray.sort((a, b) => a.sortPriority - b.sortPriority);
      return mktArray;
  }
   render() {
      let betList = this.filteredBets()
      let fancyMarkets = this.arrayGroupBy(this.state.fancyMarkets, "marketType")
      fancyMarkets = this.orgenizedFancy(fancyMarkets)
      let fmkt = this.arrayGroupBy(fancyMarkets, "marketType")
      let maketTypeList = Object.keys(fmkt).map((fnc, i) => { return fnc = { mkt: fnc, count: fmkt[fnc].length } })
      fancyMarkets = this.fancyFilterApply(fancyMarkets)
      let oddsMarkets = !!this.state.oddsMarkets ? this.sortGameCatalogues(this.state.oddsMarkets) : []

      // let maketTypeList = Object.keys(fancyMarkets).map((fnc, i) => { return fnc = { mkt: fnc, count: fancyMarkets[fnc].length } })
      // fancyMarkets = this.orgenizedFancy(fancyMarkets)
      // fancyMarkets = this.fancyFilterApply(fancyMarkets)
      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box mainbox-mobile">
                           <div className="row analysis-running-market mt-1">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                 <div className="in-play-left pb-0 mb-0 p-0">
                                    <div className="main-in-play">
                                      
                                          <React.Fragment>
                                             {/* <div className='racetitle'>
                                                <span>{!!this.state.eventData.event && !!this.state.eventData.event["countryCode"] ? this.state.eventData.event["countryCode"] : null}</span> 
                                                <span className="float-right"></span> 
                                             </div> */}
                                          <div className="top grd-background toppadding">
                                             <h4 className="w-100">
                                                <span>{ !!this.state.eventData.event && !!this.state.eventData.event.name ? this.state.eventData.event.name.substr(0,this.state.eventData.event.name.length - 9) : "" }</span> 
                                                <span className="float-right">{ !!this.state.eventData.event && !!this.state.eventData.event.name ? this.state.eventData.event.name.substr(-8) : "" }</span> 
                                             </h4>
                                          </div>
                                       </React.Fragment>
                                      
                                       {/* {!!this.state.eventDetail.eventType && (this.state.eventDetail.eventType.id === "1" || this.state.eventDetail.eventType.id === "2") && <>


                                          <div style={{ margin: "0px -8px" }}>
                                             {this.state.eventDetail.eventType.id === "1" ? <GraphicScore eventType={"footballlive"} event_id={this.props.match.params.event_id} score_id={this.state.score_id} />
                                                : this.state.eventDetail.eventType.id === "2" ? <GraphicScore eventType={"tenniscourtview"} event_id={this.props.match.params.event_id} score_id={this.state.score_id} />
                                                   : null
                                             }
                                          </div>
                                          {/* <div className="graphicscore">

                                             <a onClick={() => { this.setState({ isGraphicScore: !this.state.isGraphicScore }) }}>{!!this.state.isGraphicScore ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}</a>
                                          </div> *}
                                       </>
                                       } */}

                                    </div>
                                 </div>
                                 {/* {!!this.state.oddsMarkets && oddsMarkets.map((mkt, i) => {
                                    let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                    return (
                                       <>
                                          <WebMarket eventType={this.state.eventData.eventType.id} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} mktExpos={this.state.marketExpos} feedBooks={this.state.mktFeedBooks} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} key={"mktana_webmkt_" + i} showAvgBookPopup={(mkt, currRunnerId) => { this.showAvgBookPopup(mkt, currRunnerId) }} showMarketBetLock={(mkt) => { this.showMarketBetLock(mkt) }} openUserBooks={(mktId) => { this.openUserBooks(mkt) }} applyFilter={() => { this.applyFilter(mkt.marketId) }} betFilter={this.state.betFilter} socket={socket} market={mkt} curBets={this.state.matched_bet} />
                                       </>)
                                 })} */}
                                 {!!fancyMarkets && fancyMarkets.length > 0 && <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="main-analysis mb-2">
                                          <div className="fancybtn-new">
                                             <a style={this.state.betFilter === "LINE" ? { cursor: "pointer", color: "black" } : { cursor: "pointer" }} onClick={() => { this.applyFilter("LINE") }}>Binary {this.state.showFancy ? <i onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }} className="fa fa-minus fancyplusminusmob pl-4 " aria-hidden="true"></i> : <i onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }} className="fa fa-plus fancyplusminusmob pl-4" aria-hidden="true"></i>}</a>
                                          </div>
                                          <div className="w-100 d-block fancybg">
                                             <ul className="fancy-filter">
                                                <li><a onClick={() => { this.applyFancyFilter("all") }} className={this.state.fancyFilter === "all" ? "active" : null}>All</a></li>
                                                {maketTypeList.map((mktTyp, i) => {
                                                   return (
                                                      <li>
                                                         <a onClick={() => { this.applyFancyFilter(mktTyp.mkt) }} className={this.state.fancyFilter === mktTyp.mkt ? "active" : null}><span className="fancynew-budge">{mktTyp.count}</span>{mktTyp.mkt.split("_").join(" ")}</a>
                                                         <a onClick={() => { this.showMarketBetLock(mktTyp) }} className="bk-btn btlock5">BL <i className="fa fa-lock" aria-hidden="true"></i></a>
                                                      </li>
                                                   )
                                                })}
                                             </ul>
                                             <span className="fancyplus-icon" style={{ color: "white" }}><a onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }}>{this.state.showFancy ? <i className="fa fa-minus" aria-hidden="true"></i> : <i className="fa fa-plus" aria-hidden="true"></i>}</a></span>
                                          </div>
                                          <div className="fancybgmobile">
                                             <div className=" fancyscrollmenu" >
                                                <a onClick={() => { this.applyFancyFilter("all") }} className={this.state.fancyFilter === "all" ? "active" : null}>All</a>
                                                <span className="mfancyborderright"></span>
                                                {maketTypeList.map((mktTyp, i) => {
                                                   return (<>
                                                      <a onClick={() => { this.applyFancyFilter(mktTyp.mkt) }} className={this.state.fancyFilter === mktTyp.mkt ? "active" : null}>{mktTyp.mkt.split("_").join(" ")}<span className="fancynew-budge">{mktTyp.count}</span></a>
                                                      <a onClick={() => { this.showMarketBetLock(mktTyp) }} className="bk-btn">BL <i className="fa fa-lock" aria-hidden="true"></i></a>
                                                      <span className="mfancyborderright"></span>
                                                   </>)
                                                })}
                                             </div>
                                          </div>
                                          <div style={{ display: this.state.showFancy ? "block" : "none" }} className="table-responsive  game-wrap">
                                             <table className="w-100 analysis-running-market bookmakerfancy fancytable">
                                                <tbody>
                                                   <tr className="bet-all-new">
                                                      <td className="fancyw-65 pb-0">&nbsp;</td>
                                                      <td className="fancyw-20 pb-0 text-center">
                                                         <div>
                                                            <div className="fantitle d-inline">
                                                               <a id="btnBack" className="btn-back bg-trans" side="Back"><span className="ask-price">No</span></a>
                                                            </div>
                                                            <div className="fantitle d-inline">
                                                               <a id="btnLay" className="btn-lay bg-trans" side="Lay"><span className="ask-price">Yes</span></a>
                                                            </div>
                                                         </div>
                                                      </td>
                                                      <td className="fancyw-15 pb-0 p-relative mobile-hide">&nbsp;</td>
                                                   </tr>
                                                   {fancyMarkets.length > 0 && fancyMarkets.map((mkt, i) => {
                                                      let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                                      return (
                                                         <>
                                                            <BinaryMarket isEventUpdate={this.state.isEventUpdate} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} mktExpos={this.state.marketExpos} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} key={"mktana_fancymkt_" + i} socket={socket} showExpo={(data, price) => { this.showExpo(data, price) }} curBets={this.state.matched_bet} index={i} type={"ses"} market={mkt} />
                                                         </>)
                                                   })}
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>}
                                 {/* {!!this.state.lineMarkets && this.state.lineMarkets.length > 0 && <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="main-analysis mb-2">
                                          <div className="top">
                                             <div className="toptitle d-inline">Line Markets</div>
                                          </div>
                                          <div className="table-responsive analysis-running-market bookmakerfancy">
                                             <table className="w-100">
                                                <tbody>
                                                   {this.state.lineMarkets.length > 0 && this.state.lineMarkets.map((mkt, i) => {
                                                      return (
                                                         <>
                                                            <BinaryMarket isEventUpdate={this.state.isEventUpdate} key={"mktana_fancymkt1_" + i} index={i} type={"line"} market={mkt} />
                                                         </>)
                                                   })}
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>} */}
                              </div>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" id="main-analysis-st">
                                 <div className="desktop-tv">
                                    {!!this.state.tvUrl && this.state.tvUrl !== "" && <>
                                       <div className="center-box libtnonoff" >
                                          <p style={{ width: "100%", maxWidth: "100%" }}>
                                             <span style={{ padding: "5px 0px 0px 5px", display: "inline-block" }}>Live TV</span>
                                             <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onMouseDown={() => { this.setState({ tvShow: !this.state.tvShow }) }} >
                                                <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                                <label className="custom-control-label" for="customSwitches" ></label>
                                             </div>
                                          </p>
                                       </div>
                                       {!!this.state.tvShow && <div className="mb-0 tviframe" style={{ marginTop: "-8px" }} > <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={this.state.tvUrl} marginwidth='0' marginheight='0' frameborder='0' width='100%' height='100%' scrolling='no' allowfullscreen='allowfullscreen'></iframe></div>}
                                    </>}
                                 </div>
                                 <div className="main-analysis mb-2 ">
                                    <div className="">
                                       <div className="top">
                                          <div className="w-100">
                                             <div className={"d-inline"}>
                                                <span className="count">Daily <span className="pl-1 badge two">{this.state.dailyCount}</span></span>
                                                <span className="count pl-1 pr-1">1 Hour <span className="pl-1 badge two">{this.state.hour1Count}</span></span>
                                                <span className="count pl-1">2 Hour <span className="pl-1 badge two">{this.state.hour2Count}</span></span>
                                             </div>
                                             <div className="d-inline-block ml-2">
                                                <div className="form-group font-12 py-0 px-0 mb-0">
                                                   <select title="Market Type" className="form-control" name="marketType" value={this.state.marketType} onChange={(e) => { this.onChange(e) }}>
                                                      <option value="">All</option>
                                                      <option value="DAILY">Daily</option>
                                                      <option value="1_HOUR">1 Hour</option>
                                                      <option value="2_HOUR">2 Hour</option>
                                                   </select>
                                                </div>
                                             </div>
                                             {this.state.bets_data.length > 0 && <a className="matched-btn float-right text-white" data-toggle="modal" data-target="#mystatement" onClick={() => { this.showPopupBets() }}>View More</a>}
                                             {this.state.bets_data.length > 0 && <a className="matched-btn float-right text-white" data-toggle="modal" data-target="#mystatement" onClick={() => { this.applyFilter("") }}>View All</a>}
                                          </div>
                                       </div>
                                       <audio id="beepplay" onClick={this.beepAudioClick}>
                                          <source src={BASE_IMAGE_PATH + "/aimg/beep.mp3"} type="audio/mpeg" />
                                       </audio>
                                       <div className="table-responsive  max-hight">
                                          <table className="w-100 table-sm font-12 text-black whitespace">
                                             <thead className="">
                                                <tr className="bg-dark text-white bg-dark1">
                                                   <td>UserName</td>
                                                   <td>Market</td>
                                                   <td>Runner</td>
                                                   <td>Rate</td>
                                                   <td>Amount</td>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {betList.map((bet, i) => {
                                                   let market_time = dateUtil.getBinaryMarketDisplayName(bet.marketName)
                                                   return (
                                                      <>
                                                         {i < this.state.betListLimit && <tr key={i} bgcolor={bet.side === 0 || bet.side === "BACK" ? "#72BBEF" : bet.side === 1 || bet.side === "LAY" ? "#FAA9BA" : ""} style={{ cursor: "pointer" }} onClick={(e) => { this.showUserDetailPopup(bet) }}>
                                                            <td>{bet.username ? bet.username : "-"}</td>
                                                            <td>{!!market_time && market_time.length > 0 ?
                                                            <>
                                                               {market_time[0]} 
                                                               <small><b> [{market_time[1]}]</b></small>
                                                            </>
                                                            : bet.marketName}</td>
                                                            <td>{!!bet.runnerName ? bet.runnerName + (bet.marketBettingType === "LINE" ? " / " + bet.price : "") : "-"}</td>
                                                            <td className="fbold">{!!bet.price ? bet.price : "0.00"} </td>
                                                            <td className="fbold">{!!bet.amount ? Math.round(bet.amount)  : "0.00"}</td>
                                                         </tr>
                                                         }
                                                      </>
                                                   )
                                                })}
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
            <Footer socket={socket} />
            {this.state.showExpo && <ExpoPopup key={"mktana_expo"} expoPrice={this.state.expoPrice} lineExpo={this.state.lineExpo} hidePopup={() => { this.hideExpo() }} />}
            {this.state.showUserDetailPopup &&
               <EventUnsettledBets key={"mktana_usrone"} event_id={this.props.match.params.event_id} market_id={this.state.userDetail.marketId} newPopupData={this.state.newPopupData} newPopupDataClose={() => { this.newPopupData() }} client_id={this.state.userDetail.username} accounts={this.state.accounts} isUserBet={true} hidePopupBets={() => { this.hideUserDetailPopup() }} eventType={this.state.eventData.eventType} />
            }
            {this.state.showPopupBets &&
               <EventUnsettledBets key={"mktana_usrall"} event_id={this.props.match.params.event_id} market_id={""} client_id={""} newPopupData={this.state.newPopupData} newPopupDataClose={() => { this.newPopupData() }} accounts={this.state.accounts} isUserBet={false} hidePopupBets={() => { this.hidePopupBets() }} eventType={this.state.eventData.eventType}/>
            }
            {this.state.openUserBook && this.state.bookMktId !== "" &&
               <UserMarketBook key={"mktana_usrbook"} selectedMarket={this.state.bookMkt} closeUserBook={() => { this.closeUserBook() }} />
            }
            {this.state.avgBookPopup &&
               <AverageMarketBook market={this.state.avgMarket} currRunnerId={this.state.avgCurrRunnerId} hideAvgBookPopup={() => { this.hideAvgBookPopup() }} />
            }
            {this.state.showMarketBetLock &&
               <MarketBetLock market={this.state.betLockMkt} event_id={this.props.match.params.event_id} closeMarketBetLock={() => { this.closeMarketBetLock() }} />
            }
            {this.state.showPopupUserBook && <>
               <div id="userbook" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">User Book</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hidePopupUserBook() }}>×</button>
                        </div>
                        <div className="modal-body ac-state">
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="basic-btn" className="table table-bordered table-sm font-14 tab-ttoptip">
                                       <thead>
                                          <tr className="bg-dark text-white">
                                             <th>UserName</th>
                                             <th>Delhi Capitals</th>
                                             <th>Rajasthan Royals</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td><a href="">jackuser</a></td>
                                             <td><a href="">800</a></td>
                                             <td><a href="">-1000</a></td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopupUserBook() }}></div>
               </div>
            </>}
            {this.state.showPopupBetsLock && <>
               <div id="userwise" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-md modal-dialog-centered">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Active User</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hidePopupBetsLock() }}>×</button>
                        </div>
                        <div className="modal-body ac-state" >
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="example" className="table table-bordered table-sm font-14 nowrap">
                                       <thead>
                                          <tr>
                                             <th>User Name</th>
                                             <th>Bet Lock</th>
                                             <th>Bet Delay</th>
                                             <th>Password</th>
                                             <th>Action</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td>{!!this.state.marketBetDetail.username ? this.state.marketBetDetail.username : "-"}</td>
                                             <td className="chk-center">
                                                <label className="checkboxx"><input type="checkbox" /><span className="checkmark1"></span></label>
                                             </td>
                                             <td>
                                                <input className="form-control rw-80" type="number" id="userBetDelay" name="userBetDelay" onChange={(e) => { this.onChange(e) }} />
                                             </td>
                                             <td>
                                                <input type="Password" className="form-control rw-150" placeholder="Password" name="masterPassword" onChange={(e) => { this.onChange(e) }} />
                                             </td>
                                             <td>
                                                <button className="btn btn-blue btn-sm">Confirm</button>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop1 fade show" onClick={() => { this.props.hidePopupBetsLock() }}></div>
               </div>
            </>}
            {this.state.showPopupFancyBook && <>
               <div id="book" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Books</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hidePopupFancyBook() }}>×</button>
                        </div>
                        <div className="modal-body ac-state">
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="basic-btn" className="table table-bordered table-sm font-14 tab-ttoptip">
                                       <thead>
                                          <tr className="bg-dark text-white">
                                             <th>Run</th>
                                             <th>Amount</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr className="oddbg">
                                             <td>54</td>
                                             <td>0.00</td>
                                          </tr>
                                          <tr className="oddbg">
                                             <td>55</td>
                                             <td>0.00</td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopupFancyBook() }}></div>
               </div>
            </>}
            {this.state.showMarketBetDetail && <>
               <div id="book" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Bet Detail</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.hideMarketBetDetail() }}>×</button>
                        </div>
                        <div className="modal-body ac-state">
                           <div className="row">
                              <div className="col-12">
                                 <div className="table-responsive">
                                    <table id="example" className="w-100 table-sm font-14 text-black mb-2">
                                       <thead className="">
                                          <tr>
                                             <td>User Name</td>
                                             <td>Market</td>
                                             <td>Runner</td>
                                             <td>Side</td>
                                             <td className="text-right">Line</td>
                                             <td className="text-right">Rate</td>
                                             <td className="text-right">Amount</td>
                                             <td title="Potential Profit" className="text-right">PP</td>
                                             <td title="Potential Loss" className="text-right">PL</td>
                                             <td>Time</td>
                                             <td>IP</td>
                                             <td>Device</td>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr className={this.state.marketBetDetail.side === "BACK" ? "laybg" : "oddbg"} >
                                             <td>{!!this.state.marketBetDetail.username ? this.state.marketBetDetail.username : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.marketName ? this.state.marketBetDetail.marketName : this.state.marketBetDetail.marketBettingType}</td>
                                             <td>{!!this.state.marketBetDetail.runnerName ? this.state.marketBetDetail.runnerName : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.side ? this.state.marketBetDetail.side : "-"}</td>
                                             <td className="fbold text-right">{this.state.marketBetDetail.marketBettingType === "LINE" && !!this.state.marketBetDetail.runnerId ? this.state.marketBetDetail.runnerId : "-"}</td>
                                             <td className="fbold text-right">{!!this.state.marketBetDetail.price ? this.state.marketBetDetail.price : "-"}</td>
                                             <td className="text-right">{!!this.state.marketBetDetail.amount ? <Currency className={"fbold"} amount={this.state.marketBetDetail.amount} showColor={false} /> : "0"}</td>
                                             <td className="text-right">{!!this.state.marketBetDetail.potentialProfit ? <Currency className={"fbold text-success"} amount={this.state.marketBetDetail.potentialProfit} showColor={false} /> : "0"}</td>
                                             <td className="text-right">{!!this.state.marketBetDetail.potentialLoss ? <Currency className={"fbold text-red"} amount={this.state.marketBetDetail.potentialLoss} showColor={false} /> : "0"}</td>
                                             <td>{!!this.state.marketBetDetail.createdOn ? new Date(this.state.marketBetDetail.createdOn).toLocaleString() : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.clientIP ? this.state.marketBetDetail.clientIP : "-"}</td>
                                             <td>{!!this.state.marketBetDetail.device ? this.state.marketBetDetail.device : "-"}</td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.hideMarketBetDetail() }}></div>
               </div>
            </>}
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(BinaryAnalysisUsers);